import React from "react";
import Whatsappbanner from "./Whatsappbanner";
import Card from './Cards';
import Connect from "./Connect";

const Home = () => {
    return (
        <>
            <div>
                <Whatsappbanner />
                <Card />
                <Connect />
            </div>
        </>
    )
}

export default Home;